<template>
  <div v-if="loggingOut">
    You are currently logging out.
  </div>
  <div v-else>
    Somethings wrong
  </div>
</template>
<script>
import { mapState } from "vuex";
import auth from "../../api/auth";

export default {
  name: "LogoutPage",
  data() {
    return {
      loggingOut: true,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  async created() {
    try {
      const response = await auth.logout();
      console.log("logout response: ", response);
    } catch (error) {
      console.error("@logoutpage: error", error);
    }
  },
};
</script>
